import { ContractPartnerByGuid } from "./contract-partner-by-guid.model";
import { CPBillingCode } from "./cp-billing-code.model";
import { Crew } from "./crew.model";
import { DailyReport } from "./daily-report.model";
import { OSP } from "./osp.model";
import { Task } from "./task.model";

export class CpOspAssignments {
  contractPartner?: ContractPartnerByGuid;
  dailyReports?: DailyReport[];
  osp?: OSP;
  tasks?:boolean = false;
  cpBillingCodes?: CPBillingCode[];
  crews?: Crew[];

  constructor(data?: any) {
    if (!data) {
      return;
    }
    
    this.contractPartner = new ContractPartnerByGuid(data.contractPartner[0]);
    this.dailyReports = data.dailyReports.map(dr=>new DailyReport(dr));
    this.osp = new OSP(data.osp[0]);
    this.tasks = data.tasks.map(t=>new Task(t));
    this.cpBillingCodes = data.cpBillingCodes.map(dr=>new CPBillingCode(dr));
    this.crews = data.crews.map(c=>new Crew(c));
  }
}
